import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  // Report
  {
    path: '/report/',
    name: 'Report',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'a2a-report-geolokasi:read',
            'a2b-report-ringkasangeolokasi:read',
            'report_management_driver:read',
            'a2d-report-ringkasanharianpengemudi:read',
            'report_summary_day_vehicle:read',
            'report_stopped:read',
            'report_detail_vehicle_trip:read',
            'report_vehicle_trip:read',
            'report_management_vehicle:read',
            'report_alert:read',
            'report_driver_behaviour:read',
            'a3e-report-ringkasanpelanggaranpengemudi:read',
            'report_fuel:read',
            'report_door:read',
            'report_time_window:read',
            'raw_sensor_infos:read',
            'a4e-detailjamkerja:read',
            'a4f-detailjamkerjadanpto:read',
            'a4g-detailpto:read',
            'a3f-report-ringkasanperingatan:read',
            'a4h-summaryfuel-report:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "report" */ '@/router/views/report'),
  },

  {
    path: '/report/scheduler/',
    name: 'Report Scheduler',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a5a-penjadwalan-report:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "report" */ '@/router/views/report/scheduler'),
  },
  {
    path: '/report/scheduler/create',
    name: 'Report Scheduler Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a5a-penjadwalan-report:create'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/scheduler/form'),
  },
  {
    path: '/report/scheduler/update/:id',
    name: 'Report Scheduler Update',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a5a-penjadwalan-report:update'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/scheduler/form'),
  },
  {
    path: '/report/scheduler/history',
    name: 'Report Scheduler History',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a5a-penjadwalan-report:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/scheduler/history'),
  },
  {
    path: '/report/delivery-history',
    name: 'Report Delivery History',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'tms:create',
            'tms:read',
            'tms:update',
            'tms:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/tms/delivery-history'),
  },
  {
    path: '/report/delivery-load',
    name: 'Report Delivery Load',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'tms:create',
            'tms:read',
            'tms:update',
            'tms:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/tms/delivery-load'),
  },
  {
    path: '/report/delivery-plan-vs-actual',
    name: 'Report Delivery Plan vs Actual',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'tms:create',
            'tms:read',
            'tms:update',
            'tms:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/tms/delivery-plan-actual'),
  },
  {
    path: '/report/expenses',
    name: 'Report Expenses',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'tms:create',
            'tms:read',
            'tms:update',
            'tms:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "report" */ '@/router/views/report/tms/expenses'),
  },
  {
    path: '/report/offline-device',
    name: 'Report Offline Device',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_vehicles_offline:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/offline-device'),
  },
  {
    path: '/report/geolocationroute',
    name: 'Report Route Geolocation',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll'](['vehicles:read', 'd1a-default-mdkendaraan:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ '@/router/views/report/list/geolocationroute'),
  },
  {
    path: '/report/vehicle-trip',
    name: 'Report Vehicle Trip',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_vehicle_trip:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/vehicle-trip'),
  },
  {
    path: '/report/temperature',
    name: 'Report Temperature',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['raw_sensor_infos:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/temperature'),
  },
  {
    path: '/report/summary-stopped',
    name: 'Report Summary Stopped',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_stopped:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/summary-stopped'),
  },
  {
    path: '/report/detail-vehicle-trip',
    name: 'Report Detail Vehicle Trip',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_detail_vehicle_trip:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/detail-vehicle-trip'),
  },
  {
    path: '/report/fuel',
    name: 'Report Fuel',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_fuel:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "report" */ '@/router/views/report/list/fuel'),
  },
  {
    path: '/report/management-vehicle',
    name: 'Report Management Vehicle',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_management_vehicle:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/management-vehicle'),
  },
  {
    path: '/report/summary-day-vehicle',
    name: 'Report Summary Day Vehicle',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_summary_day_vehicle:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/summary-day-vehicle'),
  },
  {
    path: '/report/summary-fuel',
    name: 'Report Summary Fuel',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a4h-summaryfuel-report:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/summary-fuel'),
  },
  {
    path: '/report/summary-day-fuel',
    name: 'Report Daily Summary Fuel',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a4i-summaryfueldaily-report:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/summary-fuel-daily'),
  },
  {
    path: '/report/geolocation',
    name: 'Report Geolocation',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a2a-report-geolokasi:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/geolocation'),
  },
  {
    path: '/report/summary-engine',
    name: 'Report Summary Engine',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a4e-detailjamkerja:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/summary-engine'),
  },
  {
    path: '/report/summary-day-driver',
    name: 'Report Daily Summary Driver',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a2d-report-ringkasanharianpengemudi:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/summary-day-driver'),
  },
  {
    path: '/report/management-driver',
    name: 'Report Driver Management',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_management_driver:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/management-driver'),
  },
  {
    path: '/report/summary-alert',
    name: 'Report Summary Alert',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a3f-report-ringkasanperingatan:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/summary-alert'),
  },
  {
    path: '/report/alert',
    name: 'Report Alert',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_alert:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "report" */ '@/router/views/report/list/alert'),
  },
  {
    path: '/report/summary-geolocation',
    name: 'Report Summary Geolocation',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a2b-report-ringkasangeolokasi:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/summary-geolocation'),
  },
  {
    path: '/report/door',
    name: 'Report Door',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_door:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "report" */ '@/router/views/report/list/door'),
  },
  {
    path: '/report/summary-engine-pto',
    name: 'Report Summary Engine PTO',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a4f-detailjamkerjadanpto:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/summary-engine-pto'),
  },
  {
    path: '/report/time-window',
    name: 'Report Time Window',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_time_window:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/time-window'),
  },
  {
    path: '/report/detail-pto',
    name: 'Report Detail PTO',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a4g-detailpto:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/detail-pto'),
  },
  {
    path: '/report/historical-offline',
    name: 'Report Historical Offline',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_historical_offline:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/historical-offline'),
  },
  {
    path: '/report/history-connectivity-gps',
    name: 'Report History Connectivity Gps',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_raw_sensor_hour:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "report" */ '@/router/views/report/list/history-connectivity-gps'
      ),
  },
  {
    path: '/report/summary-working-hours',
    name: 'Report Summary Working Hours',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_summary_working_hours:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/summary-working-hours'),
  },
  {
    path: '/report/overspeed-duration',
    name: 'Report Overspeed Duration',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess'](['a3e-report-ringkasanpelanggaranpengemudi:read'])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/overspeed-duration'),
  },
  {
    path: '/report/service-schedule',
    name: 'Report Service Schedule',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['maintenance:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/service-schedule'),
  },
  {
    path: '/report/driver-score',
    name: 'Report Driver Score',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['b4a-penilaian-pengemudi-v2:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/driver-score'),
  },
  {
    path: '/report/geofences-trip',
    name: 'Report Trip Between Geofences',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a8-report-geofences-trip:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/trips-between-geofences'),
  },
  {
    path: '/report/history-route',
    name: 'Report History Route',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_history_route:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/history-route'),
  },
  {
    path: '/report/summary-ritage-route',
    name: 'Report Summary Ritage Route',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_summary_ritage_route:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/summary-ritage-route'),
  },
  {
    path: '/report/vehicle-status',
    name: 'Report Vehicle Status',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['report_vehicle_status:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/vehicle-status'),
  },
  {
    path: '/report/cost-analysis',
    name: 'Report Cost Analysis',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccessAll'](['tms:read', 'financial-record:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/cost-analysis'),
  },
  {
    path: '/report/geolocation-durations',
    name: 'Report Geofence Duration',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['duration_in_geolocation:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/geolocation-durations'),
  },
  {
    path: '/report/custom/:id',
    name: 'Custom Report',
    meta: {
      authRequired: true,
      hasAccess: true,
      // in case for further enhancement, this code will be commented for now.
      // beforeResolve(_, routeFrom, next) {
      //   Helper.methods.userLogging('Access', _)
      //   if (store.getters['identity/hasAccess'](['duration_in_geolocation:read'])) {
      //     next()
      //   } else {
      //     next({ name: 'Liveview' })
      //   }
      // },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/components/CustomReportPage'),
  },
  {
    path: '/report/fleet-utilization',
    name: 'Report Fleet Utilization',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccessAll'](['a11a-custom-report-mti:read', 'tms:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/tms/fleet-utilization'),
  },
  {
    path: '/report/fleet-utilization-ijp',
    name: 'Report Fleet Utilization IJP',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a11b-custom-report-ijp:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/fleet-utilization-ijp'),
  },
  {
    path: '/report/fuel-recapitulation',
    name: 'Report Fuel Recapitulation',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a2p-fuel-recapitulation:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/fuel-recapitulation'),
  },
  {
    path: '/report/summary-sensor-ciomas',
    name: 'Report Summary Sensor Ciomas',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['a11c-custom-report-ciomas:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/summary-sensor-ciomas'),
  },
  {
    path: '/report/summary-ritage',
    name: 'Report Summary Ritage',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['j2b-ritage-report:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "report" */ '@/router/views/report/list/summary-ritage'),
  },
]
